import { Button } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom'; 
import useStyles from './appointments/create/css/styles';

// Update log
// FB 8259 SK     02/27/2024    After booking appt with card details when user click back button needs to be handled

export default function LoggedOutMessage() {
    const [peURL, setPEURL] = useState("");
    const history = useHistory();
    const handleClick = () => {
        if (peURL) {
            window.open(peURL, '_blank');
        }
    };
    useEffect(() => {
        let data=sessionStorage.getItem("URL");
        if (data !=null){
            setPEURL(data);
        }
    });
    const styles = useStyles();
    return (
        <div style={{marginLeft: "30%"}}>
            <p style={{justifyContent: "center"}}>You are logged out. Please click Book Appointment to continue.</p>
            <Button
              variant="contained"
              className={styles.navigationButton}
              onClick={handleClick}
              style={{ marginLeft: "15%" }}
            >
              Book Appointment
            </Button>
        </div>
      );
};
